const translations = {
  'forthcomingCourses.title': 'Próximos cursos de TEFL',
  'forthcomingCourses.btn.applyNow': 'Solicita ahora',
  'forthcomingCourses.homepage.nextDate': 'Próxima fecha',
  'forthcomingCourses.placecAvailable': 'Plazas disponibles',

  'forthcomingCourses.course': 'Curso',
  'forthcomingCourses.from': 'Desde',
  'forthcomingCourses.to': 'Hasta',
  'forthcomingCourses.price': 'Precio',

  'activeComingCourses.notice':
    ' Los cursos de Desarrollo de Profesorado y Enseñanza de Jóvenes Estudiantes tienen fechas de inicio flexibles a lo largo de todo el año. Contáctanos para <accentedLink>  obtener más información.</accentedLink>',
  'forthcomingCourses.description':
    'The Teaching Young Learners Course follows the same start dates as our Trinity CertTESOL course. See our <accent> course dates page </accent> for more information.',
  'graduates.title': 'De nuestros graduados',
  'forthcomingCourses.title.upcoming': 'Próximas fechas del curso',
  'graduates.description': '',
  'graduates.teflSpanishCourses.title':
    'Hemos ayudado a cientos de estudiantes a certificarse como maestros y encontrar trabajo en el extranjero. ¿Serás el próximo?',
  'graduates.teflSpanishCourses.description': 'Mira lo que dijeron estos estudiantes graduados: ',
  'graduates.seeAllReviews': 'See All Reviews',
  'graduates.testimonials': 'Testimonios',
  'graduates.spanish.title':
    'Hemos Ayudado A Cientos De Estudiantes A Aprender Inglés. ¿Eres Tú El Siguiente?',
  'forthcomingCourses.active.showLess': 'Show Less Dates',
  'forthcomingCourses.active.loadMore': 'Más Fechas',
  'studentSupport.title': 'Apoyo al Estudiante',
  'studentSupport.description': 'Descubre nuestros servicios adicionales',
  'studentSupport.accommodation': 'Alojamiento',
  'studentSupport.studentVisa': 'Visa de Estudiante',
  'studentSupport.culture': 'Cultura',
  'studentSupport.bureaucracy': 'Trámites Burocráticos',
  'appProcess.title': 'El Proceso de Matriculación Para Nuestro Curso Trinity CertTESOL',
  'appProcess.ben1.title': 'Solicitud',
  'appProcess.ben1.text':
    'Consulta nuestros <accent>  requisitos de ingreso </accent> y <accent2>  cómo hacer una buena solicitud</accent2>. Completa tu solicitud en línea y comienza el proceso.',
  'appProcess.ben2.title': 'Evaluación del conocimiento del idioma',
  'appProcess.ben2.text':
    'Después de enviar tu solicitud, accederás a una prueba de nivel en línea de unos 10 minutos de duración. Esta prueba valorará si tus conocimientos de inglés cumplen con los requisitos de acceso a nuestro curso.',
  'appProcess.ben3.title': 'Entrevista',
  'appProcess.ben3.text':
    'Una vez aprobada tu prueba de nivel, tendrás una entrevista telefónica con una de nuestras coordinadoras. En unos 20-30 minutos hablarán del contenido del curso y responderán a todas tus dudas y preguntas.',
  'appProcess.ben4.title': 'Registro',
  'appProcess.ben4.text':
    'Organizaremos el pago de la matrícula y se confirmará tu lugar en el curso.',
  'appProcess.ben5.title': '¡Comienza el curso!',
  'appProcess.ben5.text':
    ' ¡Comienza la interesante aventura de tu formación! Una vez que llegues a España, estarás a  sólo un paso de emprender tu nueva carrera de profesor/a de inglés!',
  'appProcess.ben5.text.onlineCourse':
    'The fun, expert-level English teacher training begins! You’ll be given access to our live online sessions and you’re only a few weeks away from a new career as an English teacher.',

  'pricingCard.btn.checkDates': 'Ver Fechas',
};

export default translations;
